import { isFullAccess } from '../../../common/permissions/permissionUtil';
import { isGuestSelector } from '../../user/currentUserSelector';
import { currentBoardUnconstrainedUserPermissions } from './elementPermissionsSelector';

// Allow element selection unless a guest is on a public edit board.
export const selectPermissionsAllowElementSelection = (state) =>
    !(isGuestSelector(state) && isFullAccess(currentBoardUnconstrainedUserPermissions(state)));
